import React from 'react';
import ReactDOM from 'react-dom/client';
import {HashRouter, Route, Routes, Navigate} from 'react-router-dom';
import {initializeIcons} from '@fluentui/react';

import Chat from './pages/chat/Chat';
import Layout from './pages/layout/Layout';
import NoPage from './pages/NoPage';
import Login from './pages/login/Login';
import LegalDocument from './pages/legal/LegalDocument';
import {ProtectedRoute, isAuthenticated} from './pages/ProtectedRoute';
import {AppStateProvider} from './state/AppProvider';

import './index.css';

initializeIcons();

export default function App() {

    return (
        <AppStateProvider>
            <HashRouter>
                <Routes>
                    <Route
                        path="/"
                        element={isAuthenticated() ? <Navigate to="/home"/> : <Login/>}
                    />
                    <Route path="/home" element={<ProtectedRoute/>}>
                        <Route path="" element={<Layout/>}>
                            <Route index element={<Chat/>}/>
                            <Route path="*" element={<NoPage/>}/>
                        </Route>
                    </Route>
                    <Route path="/legal-document" element={<LegalDocument/>}/>
                    <Route path="*" element={<Navigate to="/"/>}/> {/* Redirect any unknown paths to login */}
                </Routes>
            </HashRouter>
        </AppStateProvider>
    );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);
